import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface SectorIndustry {
  Name: string;
}

interface SectorIndustryState {
  isLoading: boolean;
  data: SectorIndustry[] | null;
  error: string | null;
}

const initialState: SectorIndustryState = {
  isLoading: true,
  data: [],
  error: null,
};

export const fetchSectorIndustryListData = createAsyncThunk(
  "CTSectorIndustryListSlice/fetchSectorIndustryListData",
  async (_, thunkApi) => {
    try {
      const response = await httpClient.get("/product/sectorIndustry");
      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get sector/industry list",
          });
        }
      }
      return response.data;
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get sector/industry list",
      });
    }
  }
);

const CTSectorIndustryListSlice = createSlice({
  name: "CTSectorIndustryListSlice",
  initialState,
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectorIndustryListData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchSectorIndustryListData.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        fetchSectorIndustryListData.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetState } = CTSectorIndustryListSlice.actions;

export default CTSectorIndustryListSlice.reducer;
